import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogConfig as MatDialogConfig} from "@angular/material/legacy-dialog";
import * as _ from "lodash";
import * as moment from "moment";
import { BehaviorSubject, Observable, Subscription } from "rxjs";
import { first } from "rxjs/operators";
import { DatePipe } from "@angular/common";
import { Guid } from "guid-typescript";

import { PermitToStayService, UserService, MediaWatcherService } from "../../_services";
import { PermitToStayCheckListItemDocumentUploadDialogComponent } from "./checkListItemDocumentUpload";

@Component({
    templateUrl: "permitToStayCheckListItemsDialog.component.html",
    styleUrls: ["permitToStayCheckListItemsDialog.component.css"],
    providers: [DatePipe]
})
export class PermitToStayCheckListItemsDialogComponent implements OnInit, OnDestroy {
    orientationPermitToStayStudentId = 0;
    funnelId = null;
    providerId = null;
    funnel = null;
    provider = null;
    isHousingStudent = false;
    isReturningStudent = false;
    changesDetected = false;
    isMobile = false;
    orientationPermitToStayCheckListItems = [];
    mediaWatcherSubscription: Subscription;
    canBeModified = false;

    resourceDetails = new BehaviorSubject<any[]>([]);
    resourceDetails$: Observable<any> = this.resourceDetails.asObservable();

    documentDetails = new BehaviorSubject<any[]>([]);
    documentDetails$: Observable<any> = this.documentDetails.asObservable();

    quizDetails = new BehaviorSubject<any[]>([]);
    quizDetails$: Observable<any> = this.quizDetails.asObservable();

    resourceDisplayedColumns = ["fileExtension", "orientationCheckListItemDescription", "orientationPermitToStayStudentCheckListItemStatusId", "dateViewed", "orientationCheckListItemFileName", "view", "orientationCheckListItemUrl"];
    documentDisplayedColumns = ["fileExtension", "orientationCheckListItemDescription", "orientationPermitToStayStudentCheckListItemStatusId", "fileName", "dateCreated", "lastUpdatedOn", "resourceFile", "url", "edit", "view"];
    quizDisplayedColumns = ["fileExtension", "orientationCheckListItemDescription", "orientationPermitToStayStudentCheckListItemStatusId", "lastUpdatedOn", "orientationCheckListItemFileName", "orientationCheckListItemUrl", "view"];

    fileName: string = null;
    fileType: string = null;
    attachmentId: number = null;

    constructor(private dialogRef: MatDialogRef<PermitToStayCheckListItemsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) data: any,
        public dialog: MatDialog,
        private permitToStayService: PermitToStayService,
        private userService: UserService,
        private mediaWatcherService: MediaWatcherService) {
        this.orientationPermitToStayStudentId = data.orientationPermitToStayStudentId;
        this.funnelId = data.funnelId;
        this.funnel = data.funnel;
        this.provider = data.provider;
        this.providerId = data.providerId;
        this.isHousingStudent = data.isHousingStudent;
        this.isReturningStudent = data.isReturningStudent;
        this.canBeModified = data.canBeModified;
    }

    ngOnDestroy() {
        this.documentDetails.unsubscribe();
        this.mediaWatcherSubscription.unsubscribe();
    }

    ngOnInit() {
        //this.googleAnalyticsService.logPageView("/immigrationCheckListItems");

        this.mediaWatcherSubscription = this.mediaWatcherService.isTabletLarge.subscribe(isMobile => {
            this.isMobile = isMobile;

            if (this.isMobile) {
                this.resourceDisplayedColumns = ["orientationCheckListItemDescription", "orientationPermitToStayStudentCheckListItemStatusId", "dateViewed", "view", "orientationCheckListItemUrl"];
                this.documentDisplayedColumns = ["orientationCheckListItemDescription", "description", "orientationPermitToStayStudentCheckListItemStatusId", "fileName", "dateCreated", "lastUpdatedOn", "resourceFile", "orientationCheckListItemUrl", "edit", "view"];
                this.quizDisplayedColumns = ["orientationCheckListItemDescription", "orientationPermitToStayStudentCheckListItemStatusId", "lastUpdatedOn", "orientationCheckListItemUrl", "view"];
            } else {
                this.resourceDisplayedColumns = ["fileExtension", "orientationCheckListItemDescription", "orientationPermitToStayStudentCheckListItemStatusId", "dateViewed", "view", "orientationCheckListItemUrl"];
                this.documentDisplayedColumns = ["fileExtension", "orientationCheckListItemDescription", "orientationPermitToStayStudentCheckListItemStatusId", "fileName", "dateCreated", "lastUpdatedOn", "resourceFile", "orientationCheckListItemUrl", "edit", "view"];
                this.quizDisplayedColumns = ["fileExtension", "orientationCheckListItemDescription", "orientationPermitToStayStudentCheckListItemStatusId", "lastUpdatedOn", "orientationCheckListItemUrl", "view"];
            }
        });

        this.getOrientationPermitToStayStudentCheckListItems();
    }

    getOrientationPermitToStayStudentCheckListItems() {
        this.permitToStayService.getOrientationPermitToStayStudentCheckListItems(this.orientationPermitToStayStudentId, this.funnelId, this.providerId)
            .pipe(first())
            .subscribe((result: any) => {
                if (result) {
                    var resourceDetails = [];
                    var documentDetails = [];
                    var quizDetails = [];

                    _.forEach(result.filter(r => r.orientationCheckListItemTypeId === 2), (f: any) => {
                        const resourceData = {
                            id: f.id,
                            orientationCheckListItemUrl: f.orientationCheckListItemUrl,
                            orientationCheckListItemTypeId: f.orientationCheckListItemTypeId,
                            orientationCheckListItemId: f.orientationCheckListItemId,
                            orientationCheckListItemDescription: f.orientationCheckListItemDescription,
                            orientationPermitToStayCheckListItemId: f.orientationPermitToStayCheckListItemId,
                            dateCreated: f.dateCreated ? moment(f.dateCreated).format("YYYY-MM-DD") : null,
                            lastUpdatedOn: f.lastUpdatedOn ? moment(f.lastUpdatedOn).format("YYYY-MM-DD") : null,
                            dateViewed: f.dateViewed ? moment(f.dateViewed).format("YYYY-MM-DD") : null,
                            orientationPermitToStayStudentCheckListItemStatusId: f.orientationPermitToStayStudentCheckListItemStatusId,
                            orientationPermitToStayStudentCheckListItemStatusDescription: f.orientationPermitToStayStudentCheckListItemStatusDescription,
                            orientationCheckListItemAttachmentId: f.orientationCheckListItemAttachmentId,
                            orientationCheckListItemFileName: f.orientationCheckListItemFileName,
                            orientationCheckListItemFileExtension: f.orientationCheckListItemFileExtension,
                            allowMultipleOfType: f.allowMultipleOfType,
                            canBeModifiedAfterDeadline: f.canBeModifiedAfterDeadline,
                            sortOrder: f.orientationPermitToStayStudentCheckListItemStatusId === 3 ? 5 : f.orientationPermitToStayStudentCheckListItemStatusId === 6 ? 4 : f.orientationPermitToStayStudentCheckListItemStatusId === 7 ? 3 : f.orientationPermitToStayStudentCheckListItemStatusId === 9 ? 2 : 1,
                            isHighPriority: f.isHighPriority,
                            isAttachmentViewed: f.isAttachmentViewed,
                            rowversion: f.rowversion,
                            guid: Guid.create()
                        };

                        resourceDetails.push(resourceData);
                    });

                    this.resourceDetails.next(_.orderBy(resourceDetails, ["sortOrder", "isHighPriority", "orientationCheckListItemDescription"], ["asc", "desc", "asc"]));

                    _.forEach(result.filter(r => r.orientationCheckListItemTypeId === 1), (f: any) => {
                        const documentData = {
                            id: f.id,
                            attachmentId: f.attachmentId,
                            fileExtension: f.fileExtension,
                            fileName: f.fileName,
                            description: f.description,
                            orientationCheckListItemTypeId: f.orientationCheckListItemTypeId,
                            orientationCheckListItemId: f.orientationCheckListItemId,
                            orientationCheckListItemDescription: f.orientationCheckListItemDescription,
                            orientationPermitToStayCheckListItemId: f.orientationPermitToStayCheckListItemId,
                            orientationCheckListItemAttachmentId: f.orientationCheckListItemAttachmentId,
                            orientationCheckListItemFileExtension: f.orientationCheckListItemFileExtension,
                            orientationCheckListItemFileName: f.orientationCheckListItemFileName,
                            orientationCheckListItemUrl: f.orientationCheckListItemUrl,
                            dateCreated: f.dateCreated ? moment(f.dateCreated).format("YYYY-MM-DD") : null,
                            lastUpdatedOn: f.lastUpdatedOn ? moment(f.lastUpdatedOn).format("YYYY-MM-DD") : null,
                            orientationPermitToStayStudentCheckListItemStatusId: f.orientationPermitToStayStudentCheckListItemStatusId,
                            orientationPermitToStayStudentCheckListItemStatusDescription: f.orientationPermitToStayStudentCheckListItemStatusDescription,
                            isVisibleToStudent: f.isVisibleToStudent,
                            allowedUploadDocumentTypes: f.allowedUploadDocumentTypes,
                            canBeModifiedAfterDeadline: f.canBeModifiedAfterDeadline,
                            rejectedReason: f.rejectedReason,
                            sortOrder: f.orientationPermitToStayStudentCheckListItemStatusId === 5 ? 1 : f.orientationPermitToStayStudentCheckListItemStatusId === 1 ? 4 : f.orientationPermitToStayStudentCheckListItemStatusId === 4 ? 2 : f.orientationPermitToStayStudentCheckListItemStatusId === 2 ? 5 : f.orientationPermitToStayStudentCheckListItemStatusId === 6 ? 3 : 6,
                            isHighPriority: f.isHighPriority,
                            rowversion: f.rowversion,
                            attachmentRowversion: f.attachmentRowversion,
                            lastUpdatedBy: f.lastUpdatedBy,
                            uploadedByStudent: f.uploadedByStudent,
                            isManualAdd: f.isManualAdd,
                            allowMultipleOfType: f.allowMultipleOfType,
                            guid: Guid.create()
                        };

                        documentDetails.push(documentData);
                    });

                    this.documentDetails.next(_.orderBy(documentDetails, ["sortOrder", "isHighPriority", "orientationCheckListItemDescription"], ["asc", "desc", "asc"]));

                    _.forEach(result.filter(r => r.orientationCheckListItemTypeId === 3), (f: any) => {
                        const quizData = {
                            id: f.id,
                            description: f.description,
                            orientationCheckListItemTypeId: f.orientationCheckListItemTypeId,
                            orientationCheckListItemId: f.orientationCheckListItemId,
                            orientationCheckListItemDescription: f.orientationCheckListItemDescription,
                            orientationPermitToStayCheckListItemId: f.orientationPermitToStayCheckListItemId,
                            dateCreated: f.dateCreated ? moment(f.dateCreated).format("YYYY-MM-DD") : null,
                            lastUpdatedOn: f.lastUpdatedOn ? moment(f.lastUpdatedOn).format("YYYY-MM-DD") : null,
                            orientationPermitToStayStudentCheckListItemStatusId: f.orientationPermitToStayStudentCheckListItemStatusId,
                            orientationPermitToStayStudentCheckListItemStatusDescription: f.orientationPermitToStayStudentCheckListItemStatusDescription,
                            orientationCheckListItemAttachmentId: f.orientationCheckListItemAttachmentId,
                            orientationCheckListItemFileName: f.orientationCheckListItemFileName,
                            orientationCheckListItemFileExtension: f.orientationCheckListItemFileExtension,
                            orientationCheckListItemUrl: f.orientationCheckListItemUrl,
                            sortOrder: f.orientationPermitToStayStudentCheckListItemStatusId === 8 ? 1 : 2,
                            isHighPriority: f.isHighPriority,
                            allowMultipleOfType: f.allowMultipleOfType,
                            canBeModifiedAfterDeadline: f.canBeModifiedAfterDeadline,
                            rowversion: f.rowversion,
                            guid: Guid.create()
                        };

                        quizDetails.push(quizData);
                    });

                    this.quizDetails.next(_.orderBy(quizDetails, ["sortOrder", "isHighPriority", "orientationCheckListItemDescription"], ["asc", "desc", "asc"]));
                }
            });
    }

    close() {
        this.dialogRef.close(this.changesDetected);
    }

    openDocument(attachmentId: number, fileType: string) {
        this.userService.openAttachment(attachmentId)
            .pipe(first())
            .subscribe((response: any) => {
                const file = new Blob([response], { type: fileType });
                var fileUrl = URL.createObjectURL(file);
                window.open(fileUrl);
            });
    }

    modifyCheckListItem(guid: number, orientationCheckListItemTypeId: number, orientationCheckListItemAttachmentId?: number, fileType?: string) {
        let checkListItem;

        if (orientationCheckListItemTypeId === 1)
            checkListItem = this.documentDetails.value.find(f => f.guid === guid);
        else {
            if (orientationCheckListItemTypeId === 2)
                checkListItem = this.resourceDetails.value.find(f => f.guid === guid);
            else
                checkListItem = this.quizDetails.value.find(f => f.guid === guid);
        }

        if (checkListItem) {
            //documents
            if (orientationCheckListItemTypeId === 1 && checkListItem.isVisibleToStudent && checkListItem.orientationPermitToStayStudentCheckListItemStatusId !== 3 && checkListItem.orientationPermitToStayStudentCheckListItemStatusId !== 2) {
                const dialogConfig = new MatDialogConfig();

                dialogConfig.disableClose = true;
                dialogConfig.autoFocus = true;
                dialogConfig.closeOnNavigation = true;
                dialogConfig.width = "90%";
                dialogConfig.maxWidth = "75vw";
                dialogConfig.height = "auto";
                dialogConfig.panelClass = "popup-dialog-container";

                dialogConfig.data = {
                    orientationPermitToStayStudentId: this.orientationPermitToStayStudentId,
                    checkListItem: checkListItem,
                };

                const dialogRef = this.dialog.open(PermitToStayCheckListItemDocumentUploadDialogComponent, dialogConfig);

                dialogRef.afterClosed().subscribe(result => {
                    if (result) {
                        setTimeout(() => {
                            this.changesDetected = true;
                            this.getOrientationPermitToStayStudentCheckListItems();
                        }, 500);
                    }
                });
            }

            //resources that are not viewed and for which we have a file or just a url (items with url and file are only marked as read when both the file and link are opened)
            if (orientationCheckListItemTypeId === 2) {
                if (!checkListItem.dateViewed && checkListItem.orientationPermitToStayStudentCheckListItemStatusId !== 3) {
                    const saveModel = {
                        id: checkListItem.id,
                        orientationPermitToStayStudentId: this.orientationPermitToStayStudentId,
                        orientationCheckListItemTypeId: orientationCheckListItemTypeId,
                        orientationPermitToStayCheckListItemId: checkListItem.orientationPermitToStayCheckListItemId,
                        orientationPermitToStayStudentCheckListItemStatusId: !(checkListItem.orientationCheckListItemAttachmentId && checkListItem.orientationCheckListItemUrl) || ((!orientationCheckListItemAttachmentId && checkListItem.isAttachmentViewed) || (checkListItem.orientationPermitToStayStudentCheckListItemStatusId === 9 && orientationCheckListItemAttachmentId && !checkListItem.isAttachmentViewed)) ? 7 : 9,
                        isAttachmentViewed: !!orientationCheckListItemAttachmentId,
                        rowversion: checkListItem.rowversion
                    };

                    this.permitToStayService.markNonDocumentOrientationPermitToStayStudentCheckListItemAsCompleted(saveModel)
                        .pipe(first())
                        .subscribe(() => {
                            if (orientationCheckListItemAttachmentId) {
                                this.openDocument(orientationCheckListItemAttachmentId, fileType);
                            } else {
                                if (checkListItem.orientationCheckListItemUrl)
                                    window.open(checkListItem.orientationCheckListItemUrl, "_blank");
                            }

                            setTimeout(() => {
                                this.changesDetected = true;
                                this.getOrientationPermitToStayStudentCheckListItems();
                            }, 500);
                        });
                } else {
                    if (orientationCheckListItemAttachmentId) {
                        this.openDocument(orientationCheckListItemAttachmentId, fileType);
                    } else {
                        if (checkListItem.orientationCheckListItemUrl)
                            window.open(checkListItem.orientationCheckListItemUrl, "_blank"/*, "left=100,top=100,width=640,height=640"*/);
                    }
                }
            }

            ////videos
            //if (orientationCheckListItemTypeId === 3 /*&& (!this.isPastDeadline || checkListItem.canBeModifiedAfterDeadline) && checkListItem.orientationPermitToStayStudentCheckListItemStatusId !== 3 && checkListItem.orientationPermitToStayStudentCheckListItemStatusId !== 8*/) {
            //    const dialogConfig = new MatDialogConfig();

            //    dialogConfig.disableClose = true;
            //    dialogConfig.autoFocus = true;
            //    dialogConfig.closeOnNavigation = true;
            //    dialogConfig.width = "90%";
            //    dialogConfig.maxWidth = "75vw";
            //    dialogConfig.height = "auto";
            //    dialogConfig.panelClass = "popup-dialog-container";

            //    dialogConfig.data = {
            //        orientationPermitToStayStudentId: this.orientationPermitToStayStudentId,
            //        checkListItem: checkListItem,
            //        isPastDeadline: this.isPastDeadline,
            //        studentAge: this.studentAge
            //    };

            //    const dialogRef = this.dialog.open(OrientationCheckListItemVideoDialogComponent, dialogConfig);

            //    dialogRef.afterClosed().subscribe(result => {
            //        if (result) {
            //            setTimeout(() => {
            //                this.changesDetected = true;
            //                this.getOrientationPermitToStayStudentCheckListItems();
            //            }, 500);
            //        }
            //    });
            //}
        }
    }
}